<template>
  <el-popover
    placement="bottom-start"
    width="200"
    trigger="click"
    transition="el-zoom-in-top"
    class="ips-org-tree"
    popper-class="ips-org-tree__popper"
    v-model="visible"
    @hide="handleHide"
  >
    <div class="ips-org-tree__tree-container" ref="tree-container">
      <scroll>
        <el-tree
          ref="tree"
          :data="data"
          :show-checkbox="showCheckBox"
          lazy
          node-key="id"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :props="defaultProps"
          :load="loadOrg"
          @node-click="handleNodeClick"
          @check-change="handleCheckChange"
        ></el-tree>
      </scroll>
    </div>
    <el-input
      v-if="!orgNode"
      slot="reference"
      v-model="name"
      readonly
      :clearable="true"
      class="ips-org-tree__input"
      :class="{'ips-org-tree_arrow-down':!visible,'ips-org-tree_arrow-up':visible}"
      :placeholder="placeholder"
      suffix-icon="el-icon-arrow-up"
      @change="handleChange"
      @click.native="handleClick"
    ></el-input>
    <el-input
      v-else
      slot="reference"
      v-model="orgNode.name"
      :clearable="true"
      class="ips-org-tree__input"
      :class="{'ips-org-tree_arrow-down':!visible,'ips-org-tree_arrow-up':visible}"
      :placeholder="placeholder"
      suffix-icon="el-icon-arrow-up"
      @change="handleChange"
      @click.native="handleClick"
    ></el-input>
  </el-popover>
</template>
<script>
import { utils, Scroll } from "@/components";
import { COMMON_ORG_TREE } from "@/store/mutation-types";
import {mapState} from "vuex";
// import _ from "lodash";

export default {
  name: "orgTree",
  components: {
    Scroll
  },
  props: {
    value: [Object, String],
    defaultExpandedKeys: Array,
    defaultCheckedKeys: Array,
    showCheckBox: Boolean,
    placeholder: String,
    onlyValue: [String, Number],
    id: [String, Number],
    name: String,
    width: {
      default: 200
    },
    /***'
     * 对应orgKindId: ogn,dpt,pos,psm
     * 和typeSign： 3，5,7,9
     *
     * */
    filterLevel: String,
    selectLevel: String
  },
  data() {
    return {
      visible: false,
      defaultProps: {
        isLeaf: data => !data.children,
        label: "name",
        disabled: "disabled"
      },
      data: []
    };
  },
  computed: {
    ...mapState("app",["currentUser"]),
    singleSelect() {
      return !this.showCheckBox;
    },
    multiSelect() {
      return this.showCheckBox;
    },
    filterArr: function() {
      let result = ["ogn", "dpt", "pos", "psm"];
      switch (this.filterLevel) {
        case "ogn":
          result = ["ogn"];
          break;
        case "dpt":
          result = ["ogn", "dpt"];
          break;
        case "pos":
          result = ["ogn", "dpt", "pos"];
          break;
        case "psm":
          result = ["ogn", "dpt", "pos", "psm"];
          break;
        case "pro":
          result = ["ogn", "dpt"];
          break;
      }
      return result;
    },
    orgNode() {
      return this.value ? Object.assign({}, this.value) : null;
    }
  },
  methods: {
    loadOrg({ level, data }, resolve) {
      if (level === 0) {
        return this.$store
          .dispatch(COMMON_ORG_TREE, this.currentUser.tenancyCode)
          .then(result => {
            let arr = result.filter(
              o => this.filterArr.indexOf(o.orgKindId) != -1
            );
            resolve(arr);
          })
          .catch(() => {
            resolve();
          });
      } else {
        return this.$store
          .dispatch(COMMON_ORG_TREE, data.id)
          .then(result => {
            let arr = result.filter(
              o => this.filterArr.indexOf(o.orgKindId) != -1
            );
            if (this.filterLevel == "pro") {
              arr = arr.filter(o => o.typeSign != null && o.typeSign <= 9);
            }
            resolve(arr);
          })
          .catch(() => {
            resolve();
          });
      }
    },
    handleHide() {
      this.visible = false;
    },
    handleClick() {
      // this.visible = !this.visible
    },
    handleChange() {
      if (utils.isEmpty(this.name)) {
        this.$emit("input", {});
        this.$emit("change", {});
      }
    },
    finish(node) {
      this.$emit("input", node);
      this.$emit("change", node);
      this.visible = false;
      this.$emit("update:id", node.id);
      this.$emit("update:name", node.name);
    },
    handleNodeClick(node) {
      if (!this.showCheckBox) {
        if (this.onlyValue !== undefined) {
          if (this.onlyValue / 1 === node["typeSign"] / 1) {
            this.finish(node);
          }
        } else if (this.selectLevel) {
          if (this.selectLevel === node["orgKindId"]) {
            this.finish(node);
          }
        } else {
          this.finish(node);
        }
      }
    },
    handleCheckChange() {
      if (this.showCheckBox) {
        let nodes = this.$refs["tree"].getCheckedNodes(true);
        this.$emit("update:name", nodes.map(node => node.label).join());
        this.$emit("input", nodes);
        this.$emit("change", nodes);
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/dropTree.scss";
</style>
